import { PeaksInstance } from "peaks.js"

export function findNextSegment({peaksInstance, currentSegment} : {peaksInstance : PeaksInstance , currentSegment : CaptionListProps}) {
    return peaksInstance.segments.getSegments().find((segment) => {
        return segment.startTime > (currentSegment.startTime as number) ? true : false 
    })

  }
